import { GraduationCap, Wallet, FileText, MapPin } from "lucide-react";

export const ARTICLES = [
    {
        slug: "panduan-kuliah-s1-jerman-budget-100juta",
        category: "Eropa",
        title: "Panduan Lengkap Kuliah S1 di Jerman dengan Biaya di Bawah Rp 100 Juta/Tahun",
        excerpt: "Mulai dari syarat masuk, daftar universitas tuition-free, hingga tips lolos APS — semua disusun Mentor Senior kami.",
        read: "8 menit baca",
        author: "Tim Konsultan Gantari",
        published: "20 Mei 2026",
        Icon: GraduationCap,
        accent: "from-[#F5A623] to-[#D98F1B]",
        sections: [
            {
                heading: "Kenapa Jerman? Tuition-Free Tanpa Mitos",
                body: "Sebagian besar universitas negeri di Jerman tidak memungut biaya kuliah (tuition fee) untuk program S1, termasuk untuk mahasiswa internasional di sebagian besar Bundesland (negara bagian). Yang perlu Kakak bayar terutama adalah biaya semester (semesterbeitrag) sekitar 150-350 EUR per semester yang sudah termasuk tiket transportasi publik regional.",
            },
            {
                heading: "Rincian Biaya Realistis per Tahun (dalam Rupiah)",
                body: "• Biaya semester: Rp 5-10 juta\n• Akomodasi (asrama atau WG): Rp 50-65 juta\n• Makan & kebutuhan harian: Rp 25-30 juta\n• Asuransi kesehatan wajib: Rp 14-17 juta\n• Buku, transport tambahan, lain-lain: Rp 5-8 juta\nTotal: sekitar Rp 95-115 juta/tahun (tergantung kota — Berlin/Munich lebih mahal, kota seperti Leipzig atau Erlangen jauh lebih murah).",
            },
            {
                heading: "Syarat Akademik & Bahasa yang Harus Disiapkan",
                body: "Untuk masuk S1 di Jerman, lulusan SMA Indonesia umumnya tidak bisa langsung diterima dan harus mengikuti Studienkolleg (program persiapan 1 tahun) terlebih dahulu, KECUALI sudah menyelesaikan setidaknya 1 semester S1 di Indonesia di program yang diakui. Skor bahasa Jerman minimal TestDaF 4 atau DSH-2 (atau IELTS 6.5 untuk program berbahasa Inggris).",
            },
            {
                heading: "Tahap APS Jakarta — Jangan Sampai Terlewat",
                body: "APS (Akademische Prüfstelle) adalah tahap verifikasi dokumen akademik wajib untuk semua pelamar dari Indonesia. Prosesnya 6-8 minggu dan harus dilakukan SEBELUM apply ke kampus. Tim Gantari akan membantu Kakak menyiapkan dokumen, jadwal interview, dan strategi menjawab pertanyaan APS.",
            },
            {
                heading: "Universitas Top yang Ramah Kantong",
                body: "TU München, RWTH Aachen, Universität Heidelberg, Humboldt-Universität zu Berlin, Universität Leipzig, Universität Bonn. Semuanya tuition-free dan masuk top 200 dunia.",
            },
            {
                heading: "Langkah Berikutnya",
                body: "Konsultasi 1-on-1 gratis dengan Mentor Senior kami untuk validasi kelayakan dokumen, simulasi biaya keluarga, dan strategi aplikasi yang disesuaikan dengan target kampus pilihan Kakak.",
            },
        ],
    },
    {
        slug: "5-beasiswa-penuh-s2-2026",
        category: "Beasiswa",
        title: "5 Beasiswa Penuh untuk S2 yang Masih Buka di 2026 (LPDP, Chevening, DAAD, dll.)",
        excerpt: "Deadline, syarat IPK, skor bahasa, dan trik essay yang sering jadi pembeda — disusun langsung oleh alumni penerima.",
        read: "12 menit baca",
        author: "Tim Mentor LPDP",
        published: "15 Mei 2026",
        Icon: Wallet,
        accent: "from-[#0A1A2F] to-[#11294A]",
        sections: [
            {
                heading: "1. LPDP (Lembaga Pengelola Dana Pendidikan)",
                body: "Beasiswa pemerintah Indonesia untuk S2/S3 di dalam & luar negeri. Tahap pendaftaran tahun 2026 dibuka 2 kali (Januari & Juli). Syarat utama: IPK minimal 3.00 (S2 luar negeri), TOEFL iBT 80 / IELTS 6.5, LoA Unconditional dari kampus tujuan ATAU sertifikat kepemilikan dana ikatan dinas dari instansi.",
            },
            {
                heading: "2. Chevening (UK)",
                body: "Beasiswa pemerintah Inggris untuk program 1 tahun S2 di UK. Pendaftaran Agustus-November setiap tahun. Syarat: minimal 2 tahun pengalaman kerja (2.800 jam), IELTS 6.5+, dan 4 esai (Leadership, Networking, Studying in UK, Career Plan) — esai ini yang sering jadi pembeda. Tim Gantari punya template review esai dari alumni Chevening.",
            },
            {
                heading: "3. DAAD (Jerman)",
                body: "Beasiswa pemerintah Jerman dengan berbagai skema (EPOS, In-Country, dan Master's Scholarships). Cocok untuk pelamar dengan IPK 3.25+ dan pengalaman kerja relevan 2+ tahun. Cakupan: full tuition + stipend bulanan + tiket pesawat + asuransi.",
            },
            {
                heading: "4. Australia Awards (AAS)",
                body: "Beasiswa pemerintah Australia untuk S2 di Group of Eight universities. Prioritas untuk pelamar dari daerah 3T (Terdepan, Terluar, Tertinggal) dan sektor prioritas (kesehatan, pendidikan, infrastruktur). Pendaftaran Februari-April.",
            },
            {
                heading: "5. Stuned (Belanda)",
                body: "Beasiswa kolaborasi pemerintah Belanda-Indonesia untuk S2 di universitas riset Belanda. Fokus pada sektor pertanian, air, kesehatan, dan governance. Pendaftaran Februari-Maret setiap tahun.",
            },
            {
                heading: "Trik Esai yang Sering Membedakan",
                body: "(a) Jangan tulis CV ulang — esai harus menampilkan story arc personal dan dampak. (b) Pakai metode STAR (Situation, Task, Action, Result) untuk setiap contoh kepemimpinan. (c) Hubungkan visi karier dengan kontribusi konkret untuk Indonesia. (d) Minta minimal 2 alumni untuk review draft.",
            },
        ],
    },
    {
        slug: "10-pertanyaan-wawancara-visa-pelajar",
        category: "Visa",
        title: "10 Pertanyaan Wawancara Visa Pelajar yang Wajib Kamu Siapkan",
        excerpt: "Termasuk strategi menjawab pertanyaan jebakan, dokumen tambahan yang membantu approval, dan studi kasus nyata.",
        read: "6 menit baca",
        author: "Tim Visa Gantari",
        published: "12 Mei 2026",
        Icon: FileText,
        accent: "from-[#F5A623] to-[#D98F1B]",
        sections: [
            {
                heading: "Pertanyaan #1: Kenapa Memilih Negara Ini?",
                body: "Jawaban yang lemah: 'karena kuliahnya bagus'. Jawaban yang kuat: sebutkan 2-3 alasan spesifik (program studi yang tidak ada di Indonesia, riset dosen tertentu, link industri yang relevan dengan rencana karier). Hindari menyebut 'agar bisa kerja di sana' — fokus pada studi.",
            },
            {
                heading: "Pertanyaan #2: Kenapa Universitas Ini?",
                body: "Siapkan jawaban yang spesifik: ranking program (bukan ranking kampus secara umum), nama dosen yang penelitiannya selaras dengan minat, fasilitas riset, atau kerja sama industri. Tunjukkan Kakak sudah melakukan riset.",
            },
            {
                heading: "Pertanyaan #3: Bagaimana Membiayai Studi & Hidup di Sana?",
                body: "Pertanyaan ini paling sering jadi alasan penolakan. Jawab dengan struktur: total biaya per tahun → sumber dana (orang tua, beasiswa, tabungan) → bukti dokumen yang dilampirkan. Hindari jawaban vague seperti 'orang tua punya bisnis'.",
            },
            {
                heading: "Pertanyaan #4: Apa Rencana Setelah Lulus?",
                body: "Untuk visa pelajar (bukan immigrant visa), Kakak HARUS menunjukkan ikatan kuat untuk kembali ke Indonesia: pekerjaan menunggu, properti keluarga, atau rencana wirausaha konkret. Tunjukkan komitmen pulang.",
            },
            {
                heading: "Pertanyaan #5-10 (Ringkas)",
                body: "(5) Siapa yang mendaftarkan/membantu visa? (6) Apa hubungan dengan keluarga yang sudah di luar negeri? (7) Pernah ke negara ini sebelumnya? (8) Apa cadangan plan kalau ditolak? (9) Berapa lama berencana tinggal? (10) Bagaimana memilih kota tempat tinggal?",
            },
            {
                heading: "Dokumen Pendukung yang Sering Membantu",
                body: "• Surat keterangan kerja orang tua + slip gaji 3 bulan\n• Rekening koran 6 bulan (saldo minimal 1.5x biaya 1 tahun)\n• Sertifikat properti keluarga\n• Itinerary studi & rencana karier 5 tahun (1 halaman)\n• Surat referensi dari dosen pembimbing S1",
            },
        ],
    },
    {
        slug: "dari-bekasi-ke-warwick-perjalanan-founder-oki",
        category: "Kisah Inspiratif",
        title: "Dari Kabupaten Bekasi ke UK: Perjalanan Oki Menembus Warwick Lewat Beasiswa LPDP",
        excerpt: "Lulusan SD Negeri di Bekasi dan S1 Matematika UI ini membuktikan anak daerah bisa menaklukkan salah satu kampus elit Inggris, hingga kini sukses menjadi full-time entrepreneur. Simak perjalanannya kerja 3 tahun hingga raih LPDP.",
        read: "10 menit baca",
        author: "Oki Saputra · Founder Gantari Edu",
        published: "10 Mei 2026",
        Icon: MapPin,
        accent: "from-[#0A1A2F] to-[#11294A]",
        featured: true,
        sections: [
            {
                heading: "Mulai dari SD Negeri di Kabupaten Bekasi",
                body: "Saya tumbuh di sebuah kabupaten di Bekasi, bersekolah di SD Negeri yang fasilitasnya seadanya. Kuliah ke luar negeri saat itu rasanya seperti mimpi yang terlalu jauh — bahkan paspor pun belum punya. Tapi rasa penasaran terhadap dunia luar selalu ada, terutama setelah saya tahu ada banyak Indonesian yang berhasil menembus kampus-kampus elit dunia hanya dengan modal kemauan dan strategi yang tepat.",
            },
            {
                heading: "S1 Matematika UI: Membangun Fondasi",
                body: "Saya diterima di program Matematika Universitas Indonesia. Ini bukan jurusan favorit, tapi saya pilih karena tahu fondasi matematika & logika akan membuka banyak pintu karier. Saya aktif di organisasi, ikut kompetisi, dan mulai membangun network yang nantinya jadi krusial. IPK saya bukan sempurna, tapi cukup untuk memenuhi syarat beasiswa luar negeri.",
            },
            {
                heading: "3 Tahun Kerja: Membangun Profil & Tabungan Cadangan",
                body: "Setelah lulus, saya bekerja selama 3 tahun di sektor yang relevan dengan rencana studi lanjut. Kenapa kerja dulu? Tiga alasan: (1) profil profesional yang kuat sangat dilihat panitia beasiswa, (2) saya butuh waktu untuk menentukan jurusan S2 yang benar-benar selaras dengan visi karier, dan (3) tabungan cadangan untuk situasi darurat selama proses aplikasi.",
            },
            {
                heading: "Apply LPDP: Strategi Esai & Wawancara",
                body: "LPDP punya 3 tahap krusial: seleksi administrasi, seleksi bakat skolastik (kemampuan), dan seleksi substansi (wawancara + LGD). Untuk esai 'Kontribusi untuk Indonesia', saya tidak menulis grand vision yang abstrak — saya tulis rencana konkret 5-10 tahun setelah lulus. Untuk wawancara, saya berlatih 30+ jam dengan alumni LPDP. Yang paling penting: konsistensi narasi antara CV, esai, dan jawaban wawancara.",
            },
            {
                heading: "Memilih Warwick: Bukan Asal Ranking",
                body: "Saya tidak memilih Oxford atau Cambridge karena LPDP membatasi kampus tertentu dan saya juga ingin program yang punya fokus spesifik pada area saya. Warwick — top 10 UK dan top 70 dunia, dengan reputasi kuat di area saya — adalah pilihan yang lebih realistis dan tepat sasaran. Pelajaran: pilih kampus yang programnya benar-benar match, bukan asal nama besar.",
            },
            {
                heading: "Hidup di UK: Tantangan & Pelajaran",
                body: "Cuaca yang dingin, makanan yang asing, dan biaya hidup yang shocking di awal. Tapi yang paling menantang adalah culture shock akademik: gaya diskusi yang sangat terbuka, beban reading 200+ halaman per minggu, dan ekspektasi critical thinking yang tinggi. Saya butuh 3 bulan untuk menyesuaikan diri.",
            },
            {
                heading: "Pulang & Memulai Gantari Edu",
                body: "Saya pulang dengan satu tekad: anak-anak Indonesia dari kabupaten manapun, dari sekolah negeri manapun, harus tahu bahwa kampus dunia itu accessible. Bukan privilege segelintir orang. Itulah kenapa Gantari Edu lahir dengan model 'Human-First, Tech-Powered' — kami pakai teknologi untuk mempercepat analisa, tapi mentor manusia yang mendampingi setiap langkah personal.",
            },
            {
                heading: "Pesan untuk Adik-Adik di Daerah",
                body: "Kuliah luar negeri bukan tentang dari mana kamu berasal — tapi tentang seberapa serius kamu menyiapkan diri 2-3 tahun ke depan. IPK boleh tidak sempurna, asal kamu punya story yang kuat, action plan yang jelas, dan support system yang tepat. Kalau Kakak butuh teman ngobrol, pintu Gantari Edu selalu terbuka.",
            },
        ],
    },
];

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
